if (!customElements.get('ip-cart-terms')) {
  class IpCartTerms extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.ip-cart-terms__checkbox');
      if (!this.checkbox) return;

      const formId = this.checkbox.getAttribute('form') || 'ip-cart-form';
      this.form = document.getElementById(formId);

      if (this.form) {
        this._handleSubmit = this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this._handleSubmit);
      }
    }

    disconnectedCallback() {
      if (this.form && this._handleSubmit) {
        this.form.removeEventListener('submit', this._handleSubmit);
      }
    }

    handleSubmit(evt) {
      if (!this.checkbox.checked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.checkbox.classList.add('ip-cart-terms__checkbox--error');
        this.checkbox.focus();
        setTimeout(() => {
          this.checkbox.classList.remove('ip-cart-terms__checkbox--error');
        }, 500);
      }
    }
  }
  customElements.define('ip-cart-terms', IpCartTerms);
}
